import airbrake from '../airbrake';
import yii from '../dependencias/yii';


export class LoginWp {
    private ultimoEmail: string | null = null;
    private $email = $('#loginform-email');
    private temporizador?: number;
    private retardo = 500;

    init() {
        if (!$('#login-form').data('sso-on')) {
            return;
        }

        this.$email.on('input', () => {
            if (this.temporizador) window.clearTimeout(this.temporizador);
            this.temporizador = window.setTimeout(() => this.checkEmail(), this.retardo);
        });

        this.$email.on('blur', () => {
            if (this.temporizador) window.clearTimeout(this.temporizador);
            this.checkEmail();
        });
    }

    private emailEsValido(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    private checkEmail() {
        const email = (this.$email.val() || '').toString().trim();

        if (email === this.ultimoEmail) {
            return;
        }

        this.ultimoEmail = email;

        if (!this.emailEsValido(email)) {
            this.toggleLoginSso(false);
            return;
        }

        fetch('/sso/validar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': yii.getCsrfToken(),
            },
            body: JSON.stringify({email: email}),
        }).then(response => response.json())
            .then(response => this.toggleLoginSso(response))
            .catch((error) => {
                airbrake.notify(error);
                this.toggleLoginSso(false);
            });
    }

    private toggleLoginSso(mostrar: boolean) {
        const $loginDefault = $('#login-form .default');
        const $loginSso = $('#login-form .sso');
        const $sso = $('#loginform-sso');

        const ssoVisible = $loginSso.is(':visible');

        if (mostrar) {
            if (!ssoVisible) {
                $loginSso.stop(true, true).slideDown(200);
                $loginDefault.stop(true, true).slideUp(200);
            }
        } else {
            if (ssoVisible) {
                $loginSso.stop(true, true).slideUp(200);
                $loginDefault.stop(true, true).slideDown(200);
            }
        }

        $sso.val(mostrar ? '1' : '0');
    }
}

airbrake.call(() => $(document).ready(() => new LoginWp().init()));
